var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('browse',{attrs:{"idKey":"process_instance_id","isEdit":_vm.isEdit,"type":_vm.processType,"columns":_vm.columns,"dataSource":_vm.dataSource}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }